// Ref: https://dx-interception-testing-api.sati.co.th/api/his/re-dx/:hn
import reDiagnosis from "dto/reDiagnosis.dto";
import dxInterceptionApi from "services/dxInterception.api";

const reDiagnosisService = {
    getAll: (
        HospitalNumber: string,
        query: {
            doctorId?: string;
            service?: string;
        }
    ) => {
        return dxInterceptionApi.get<{ data: reDiagnosis[]; total: number }>(
            `his/re-dx/${HospitalNumber}`,
            {
                params: {
                    ...query
                }
            }
        );
    }
};

export default reDiagnosisService;
